export const PreregistrationSteps = {
  EventFound: "event-found",
  EventNotFound: "event-not-found",
  ExistingParticipant: "existing-participant",
  NewParticipant: "new-participant",
  RegistrationSuccessful: "registration-successfull",
};
